export class CubicleLayout {
  pictureFileName: string;
  constructor(pictureFileName: string) {
    this.pictureFileName = pictureFileName;
  }
}
